import {default as CreditCardGateway} from './CreditCardGateway';
import {default as InlineCreditCardGateway} from './InlineCreditCardGateway';
import {default as CustomCreditCardGateway} from './CustomCreditCardGateway';

export const createCreditCardGateway = (type, props) => {
    switch (type) {
        case 'inline':
            return new InlineCreditCardGateway(props);
        case 'custom':
            return new CustomCreditCardGateway(props);
        case 'payment':
        default:
            return new CreditCardGateway(props);
    }
}